import { useUserStore } from '~/stores/user';

class MFAInProgress implements Middleware {
    name() {
        return 'mfa_in_progress';
    }

    async run() {
        const userStore = useUserStore();

        if (userStore.mfa) return;

        return {
            name: 'login.index',
        };
    }
}

export default new MFAInProgress();
